import { MerkleTree } from 'merkletreejs';
import { keccak256, solidityKeccak256 } from 'ethers/lib/utils';
import { CID } from 'multiformats/cid';
import { create } from 'multiformats/hashes/digest';
import { getNetwork } from '@ethersproject/providers';
import { utils, Contract } from 'ethers';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

const _abi$1 = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "approved",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Approval",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "operator",
    type: "address"
  }, {
    indexed: false,
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "ApprovalForAll",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    components: [{
      internalType: "string",
      name: "placeholder",
      type: "string"
    }, {
      internalType: "string",
      name: "base",
      type: "string"
    }, {
      internalType: "uint64",
      name: "supply",
      type: "uint64"
    }, {
      internalType: "bool",
      name: "permanent",
      type: "bool"
    }],
    indexed: false,
    internalType: "struct F0.Config",
    name: "config",
    type: "tuple"
  }],
  name: "Configured",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "key",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "cid",
    type: "bytes32"
  }],
  name: "Invited",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "string",
    name: "name",
    type: "string"
  }, {
    indexed: false,
    internalType: "string",
    name: "symbol",
    type: "string"
  }],
  name: "NSUpdated",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "previousOwner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "OwnershipTransferred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    components: [{
      internalType: "address",
      name: "account",
      type: "address"
    }, {
      internalType: "bool",
      name: "permanent",
      type: "bool"
    }],
    indexed: false,
    internalType: "struct F0.Withdrawer",
    name: "withdrawer",
    type: "tuple"
  }],
  name: "WithdrawerUpdated",
  type: "event"
}, {
  inputs: [],
  name: "URI",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "approve",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }],
  name: "burn",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "config",
  outputs: [{
    internalType: "string",
    name: "placeholder",
    type: "string"
  }, {
    internalType: "string",
    name: "base",
    type: "string"
  }, {
    internalType: "uint64",
    name: "supply",
    type: "uint64"
  }, {
    internalType: "bool",
    name: "permanent",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "getApproved",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_receiver",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_count",
    type: "uint256"
  }],
  name: "gift",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "string",
    name: "name",
    type: "string"
  }, {
    internalType: "string",
    name: "symbol",
    type: "string"
  }, {
    components: [{
      internalType: "string",
      name: "placeholder",
      type: "string"
    }, {
      internalType: "string",
      name: "base",
      type: "string"
    }, {
      internalType: "uint64",
      name: "supply",
      type: "uint64"
    }, {
      internalType: "bool",
      name: "permanent",
      type: "bool"
    }],
    internalType: "struct F0.Config",
    name: "_config",
    type: "tuple"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "invite",
  outputs: [{
    internalType: "uint128",
    name: "price",
    type: "uint128"
  }, {
    internalType: "uint64",
    name: "start",
    type: "uint64"
  }, {
    internalType: "uint64",
    name: "limit",
    type: "uint64"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "operator",
    type: "address"
  }],
  name: "isApprovedForAll",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "bytes32",
      name: "key",
      type: "bytes32"
    }, {
      internalType: "bytes32[]",
      name: "proof",
      type: "bytes32[]"
    }],
    internalType: "struct F0.Auth",
    name: "auth",
    type: "tuple"
  }, {
    internalType: "uint256",
    name: "_count",
    type: "uint256"
  }],
  name: "mint",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "nextId",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "ownerOf",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "renounceOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "royalty",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "royaltyInfo",
  outputs: [{
    internalType: "address",
    name: "receiver",
    type: "address"
  }, {
    internalType: "uint256",
    name: "royaltyAmount",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "safeTransferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_data",
    type: "bytes"
  }],
  name: "safeTransferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "operator",
    type: "address"
  }, {
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "setApprovalForAll",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "string",
      name: "placeholder",
      type: "string"
    }, {
      internalType: "string",
      name: "base",
      type: "string"
    }, {
      internalType: "uint64",
      name: "supply",
      type: "uint64"
    }, {
      internalType: "bool",
      name: "permanent",
      type: "bool"
    }],
    internalType: "struct F0.Config",
    name: "_config",
    type: "tuple"
  }],
  name: "setConfig",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "_key",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "_cid",
    type: "bytes32"
  }, {
    components: [{
      internalType: "uint128",
      name: "price",
      type: "uint128"
    }, {
      internalType: "uint64",
      name: "start",
      type: "uint64"
    }, {
      internalType: "uint64",
      name: "limit",
      type: "uint64"
    }],
    internalType: "struct F0.Invite",
    name: "_invite",
    type: "tuple"
  }],
  name: "setInvite",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "string",
    name: "name_",
    type: "string"
  }, {
    internalType: "string",
    name: "symbol_",
    type: "string"
  }],
  name: "setNS",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_address",
    type: "address"
  }],
  name: "setRoyalty",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "string",
    name: "_uri",
    type: "string"
  }],
  name: "setURI",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "address",
      name: "account",
      type: "address"
    }, {
      internalType: "bool",
      name: "permanent",
      type: "bool"
    }],
    internalType: "struct F0.Withdrawer",
    name: "_withdrawer",
    type: "tuple"
  }],
  name: "setWithdrawer",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "symbol",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "tokenURI",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "transferOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "withdraw",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [],
  name: "withdrawer",
  outputs: [{
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    internalType: "bool",
    name: "permanent",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}];
class F0__factory {
  static createInterface() {
    return new utils.Interface(_abi$1);
  }

  static connect(address, signerOrProvider) {
    return new Contract(address, _abi$1, signerOrProvider);
  }

}

_defineProperty(F0__factory, "abi", _abi$1);

const _abi = [{
  inputs: [],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "receiver",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "collection",
    type: "address"
  }],
  name: "CollectionAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "previousOwner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "OwnershipTransferred",
  type: "event"
}, {
  inputs: [{
    internalType: "address",
    name: "_receiver",
    type: "address"
  }, {
    internalType: "address",
    name: "_collection",
    type: "address"
  }],
  name: "addCollection",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_receiver",
    type: "address"
  }, {
    internalType: "string",
    name: "name",
    type: "string"
  }, {
    internalType: "string",
    name: "symbol",
    type: "string"
  }, {
    components: [{
      internalType: "string",
      name: "placeholder",
      type: "string"
    }, {
      internalType: "string",
      name: "base",
      type: "string"
    }, {
      internalType: "uint64",
      name: "supply",
      type: "uint64"
    }, {
      internalType: "bool",
      name: "permanent",
      type: "bool"
    }],
    internalType: "struct F0.Config",
    name: "config",
    type: "tuple"
  }],
  name: "genesis",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "renounceOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "transferOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
class F0Factory__factory {
  static createInterface() {
    return new utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new Contract(address, _abi, signerOrProvider);
  }

}

_defineProperty(F0Factory__factory, "abi", _abi);

/* Autogenerated file. Do not edit manually. */

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  F0__factory: F0__factory,
  F0Factory__factory: F0Factory__factory
});

class InviteList {
  constructor(addresses) {
    _defineProperty(this, "addresses", void 0);

    _defineProperty(this, "hashedAddresses", void 0);

    _defineProperty(this, "tree", void 0);

    this.addresses = addresses;
    this.hashedAddresses = addresses.map(this.hash);
    this.tree = new MerkleTree(this.hashedAddresses, keccak256, {
      sortPairs: true
    });
  }

  hash(address) {
    return Buffer.from(solidityKeccak256(['address'], [address]).slice(2), 'hex');
  }

  root() {
    return this.tree.getHexRoot();
  }

  proof(address) {
    return this.tree.getHexProof(this.hash(address));
  }

  verify(address, proof) {
    return this.tree.verify(proof, this.hash(address), this.root());
  }

}

const digestToCid = hex => {
  var _hex$slice$match;

  if (hex === '0x00') {
    return '';
  }

  const arr = new Uint8Array(((_hex$slice$match = hex.slice(2).match(/.{1,2}/g)) === null || _hex$slice$match === void 0 ? void 0 : _hex$slice$match.map(byte => parseInt(byte, 16))) || []);
  const digest = create(18, arr);
  const cid = CID.createV1(0x55, digest);
  return cid.toString();
};
const cidToDigest = cid => {
  if (!cid || cid.length === 0) {
    return '0x00';
  }

  const digest = CID.parse(cid).multihash.digest;
  const bytes = digest.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');
  return '0x' + bytes;
};

function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}

function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}

function _classApplyDescriptorSet(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }

    descriptor.value = value;
  }
}

function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }

  return privateMap.get(receiver);
}

function _classPrivateFieldSet(receiver, privateMap, value) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
  _classApplyDescriptorSet(receiver, descriptor, value);
  return value;
}

function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }

  return descriptor.value;
}

function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
  return _classApplyDescriptorGet(receiver, descriptor);
}

const PUBLIC_INVITE = '0x0000000000000000000000000000000000000000000000000000000000000000';
class F0MintResponse {
  constructor(tx) {
    _defineProperty(this, "tx", void 0);

    this.tx = tx;
  }

  async wait() {
    var _receipt$events;

    const receipt = await this.tx.wait();
    const transfers = ((_receipt$events = receipt.events) === null || _receipt$events === void 0 ? void 0 : _receipt$events.filter(e => e.event === 'Transfer')) || [];
    const tokenIds = transfers.map(event => event.args.tokenId).map(bn => bn.toNumber());
    return tokenIds;
  }

}

var _data = /*#__PURE__*/new WeakMap();

class F0 {
  constructor(contract) {
    _defineProperty(this, "contract", void 0);

    _classPrivateFieldInitSpec(this, _data, {
      writable: true,
      value: void 0
    });

    this.contract = contract;
  }

  getData() {
    return _classPrivateFieldGet(this, _data);
  }

  async fetch() {
    const [name, symbol, invites] = await Promise.all([this.contract.name(), this.contract.symbol(), this.invites()]);

    _classPrivateFieldSet(this, _data, {
      name,
      symbol,
      invites
    });

    return _classPrivateFieldGet(this, _data);
  }

  async invites() {
    const filter = this.contract.filters.Invited();
    const inviteEvents = await this.contract.queryFilter(filter);
    const uniqueInvites = [...new Map(inviteEvents.map(event => [event.args.key, event])).values()];
    return await Promise.all(uniqueInvites.map(async event => {
      const condition = await this.contract.invite(event.args.key);
      const invite = {
        name: event.args.key,
        key: event.args.key,
        cid: digestToCid(event.args.cid),
        condition: {
          limit: condition.limit.toNumber(),
          price: condition.price,
          start: new Date(condition.start.toNumber() * 1000)
        }
      };

      if (invite.key === PUBLIC_INVITE) {
        invite.name = 'Public mint';
        return invite;
      }

      const request = await fetch("https://ipfs.io/ipfs/".concat(invite.cid));
      const response = await request.json();
      invite.name = response.name;
      invite.list = new InviteList(response.addresses);
      return invite;
    }));
  }

  authTuple(key, address) {
    var _key;

    key = (_key = key) !== null && _key !== void 0 ? _key : PUBLIC_INVITE;

    if (!_classPrivateFieldGet(this, _data)) {
      throw new Error('Data is not fetched');
    }

    const invite = _classPrivateFieldGet(this, _data).invites.find(i => i.key === key);

    if (!invite) {
      throw new Error("Unknown invite: ".concat(key));
    }

    if (!invite.list) {
      return {
        key,
        proof: []
      };
    }

    const proof = invite.list.proof(address);
    return {
      key,
      proof
    };
  }

  async mint(count, key) {
    var _this$contract$signer, _key2;

    const address = await ((_this$contract$signer = this.contract.signer) === null || _this$contract$signer === void 0 ? void 0 : _this$contract$signer.getAddress());

    if (!address) {
      throw new Error('Cannot mint: minter address unavailable');
    }

    key = (_key2 = key) !== null && _key2 !== void 0 ? _key2 : PUBLIC_INVITE;
    const auth = this.authTuple(key, address);
    const tx = await this.contract.mint(auth, count);
    return new F0MintResponse(tx);
  }

}

//   1: '0x4d70631664f1CEc37D33f289A3293662D70741C3',
//   4: '0xB4051d6205f6B98e5CB1238DaA279D8b875BF144',
// }

class F0Factory {
  constructor(signer, network) {
    _defineProperty(this, "signer", void 0);

    _defineProperty(this, "network", void 0);

    this.signer = signer;
    this.network = getNetwork(network);
  } // async deploy(name: string, symbol: string, config: F0Contract.ConfigStruct) {
  //   const factoryAddress = addresses[this.network.chainId]
  //   if (!factoryAddress) {
  //     throw new Error(
  //       `Unsupported network: ${this.network.name} (${this.network.chainId})`,
  //     )
  //   }
  //   const factory = F0ContactFactories.F0Factory__factory.connect(
  //     factoryAddress,
  //     this.signer,
  //   )
  //   const tx = await factory.genesis(
  //     await this.signer.getAddress(),
  //     name,
  //     symbol,
  //     config,
  //   )
  //   // TODO:
  // }


  async connect(contractAddress) {
    const contract = F0__factory.connect(contractAddress, this.signer);
    const f0 = new F0(contract);
    await f0.fetch();
    return f0;
  }

}

export { F0, index as F0ContactFactories, F0Factory, InviteList, cidToDigest, digestToCid };
